import React from "react";
import { Card, CardContent, CardHeader, Grid } from "@mui/material";
import {
  OneColumn,
  MenuItemsForDropDown,
  IDType,
  IDTypeSelectComponent,
  PassportComponent,
} from "@soqs/common";

import { useFormState } from "react-final-form";
import { dropdownopts, dropdownsloading } from "../../features/AppSlice";
import { useSelector } from "react-redux";
import DropDownSelectComponent from "./usercomponents/DropDownSelectComponent";
import FraudEmailFieldComponent from "./usercomponents/FraudEmailFieldComponent";
import FraudIDNumberComponent from "./usercomponents/FraudIDNumberComponent";
import InitialsField from "./usercomponents/FraudInitialsField";

import FraudPhoneFieldComponent from "./usercomponents/FraudPhoneFieldComponent";
import FraudName from "./usercomponents/FraudName";
import FraudField from "./usercomponents/FraudField";

const SARSEmployeeDetails = (_props) => {
  const dropdownloading = useSelector(dropdownsloading);
  const dropdownoptions = useSelector(dropdownopts);
  const formstate = useFormState();

  return (
    <Grid size={{ xs: 12 }}>
      <Card>
        <CardHeader title="SARS Employee Details" />
        <CardContent>
          <Grid container columnSpacing={1.5} rowSpacing={0.5}>
            <OneColumn>
              <DropDownSelectComponent
                label="Gender"
                name="gender"
                required={false}
                options={MenuItemsForDropDown("gender", dropdownoptions, false)}
                optionsloading={dropdownloading}
              />
            </OneColumn>
            <OneColumn>
              <InitialsField
                name="initials"
                label="Initials"
                required={false}
              />
            </OneColumn>
            <OneColumn>
              <FraudName label="First Name" name="name" required={false} />
            </OneColumn>
            <OneColumn>
              <FraudName label="Surname" name="surname" required={false} />
            </OneColumn>
            <OneColumn>
              <FraudField
                name="capacity"
                label="Capacity/Role"
                fieldlength={20}
                maxlength={20}
                rows={1}
                required={false}
              />
            </OneColumn>
            <OneColumn>
              <FraudField
                name="office"
                label="Office"
                fieldlength={30}
                maxlength={30}
                rows={1}
                required={false}
              />
            </OneColumn>

            <OneColumn>
              <IDTypeSelectComponent
                label="ID Type"
                name="idtype"
                required={false}
                idoptions={MenuItemsForDropDown(
                  "idtype",
                  dropdownoptions,
                  true
                )}
                optionsloading={dropdownloading}
              />
            </OneColumn>

            <OneColumn>
              {formstate.values?.idtype === IDType.RSA_Id ? (
                <FraudIDNumberComponent
                  name="idnumber"
                  label="Identification Number"
                  required={false}
                />
              ) : (
                <PassportComponent
                  name="taxpayerpassport"
                  label="Passport Number"
                  required={false}
                />
              )}
            </OneColumn>

            <OneColumn>
              <FraudPhoneFieldComponent
                name="cell"
                label="Contact Cell"
                required={false}
              />
            </OneColumn>
            <OneColumn>
              <FraudEmailFieldComponent
                name="email"
                label=" Contact Email"
                required={false}
              />
            </OneColumn>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default SARSEmployeeDetails;
